import { render } from "./LoadingTestPanel.vue?vue&type=template&id=0fee7a80&scoped=true&ts=true"
import script from "./LoadingTestPanel.vue?vue&type=script&lang=ts"
export * from "./LoadingTestPanel.vue?vue&type=script&lang=ts"

import "./LoadingTestPanel.vue?vue&type=style&index=0&id=0fee7a80&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fee7a80"]])

export default __exports__